module.exports = __webpack_public_path__ + "static/media/Group277.a6caad57.png";